import React from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { SEARCH_PARAM_ACTIVE_TAB } from "../utils/constants";

const useTabs = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const location = useLocation();
	const navigate = useNavigate();

	const activeTab = React.useMemo(() => searchParams.get(SEARCH_PARAM_ACTIVE_TAB), [searchParams]);

	const getTabLink = React.useCallback(
		(tab: string) => {
			const pathname = location.pathname === "/requests" ? "/" : location.pathname;

			const params = new URLSearchParams(searchParams);
			params.set(SEARCH_PARAM_ACTIVE_TAB, tab);

			return `${pathname}?${params.toString()}`;
		},
		[location.pathname, searchParams]
	);

	const setActiveTab = React.useCallback(
		(tab: string) => {
			if (location.pathname === "/requests") {
				navigate(getTabLink(tab));
				return;
			}

			setSearchParams((prev) => {
				const next = new URLSearchParams(prev);
				next.set(SEARCH_PARAM_ACTIVE_TAB, tab);
				return next;
			});
		},
		[getTabLink, location.pathname, navigate, setSearchParams]
	);

	return {
		activeTab,
		setActiveTab,
		getTabLink,
	};
};

export default useTabs;
